<mat-form-field class="bold-required-field">
  <mat-label>
    {{ fieldLabel }}
  </mat-label>
  <input
    matInput
    [formControl]="fieldControl"
    [attr.test-id]="testId"
    (input)="searchFn($event)"
    [matAutocomplete]="deliveryAddressAuto"
    [readonly]="disableField"
  />
  <mat-autocomplete
    requireSelection
    (optionSelected)="onOptionSelected($event)"
    #deliveryAddressAuto="matAutocomplete"
    [displayWith]="displayValueFn"
  >
    @for (carrier of carriers; track carrier.extId) {
    <mat-option [value]="carrier">
      {{ carrier.name }}
      @if (carrier.extId) {
      <span class="carrier-info">
        {{ carrier.extId }}
      </span>
      } @if (carrier.number) {
      <span class="carrier-info"> ({{ carrier.number }}) </span>
      }
    </mat-option>
    } @if (isLoadMoreEnabled) {
    <div class="load-more" (mousedown)="$event.preventDefault()">
      <span class="link" (click)="onLoadMore()">
        <ui-svg-icon [name]="iconNames.Refresh" class="tw-align-middle"></ui-svg-icon>
        {{ 'monitoring.uli.create.uliInfo.loadMoreAddress' | translate : { amount: loadMoreAmount } }}
      </span>
    </div>
    }
  </mat-autocomplete>
  @if (fieldControl.invalid && (fieldControl.dirty || fieldControl.touched)) {
  <mat-error>
    <ui-field-error-messages [control]="fieldControl"></ui-field-error-messages>
  </mat-error>
  }
</mat-form-field>
